/**
 * Format date string to Turkish format
 * "2025-01-15" → "15 Ocak 2025"
 */
const TURKISH_MONTHS = [
  'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
  'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'
];

export function formatDateTR(dateStr) {
  if (!dateStr) return '';
  const parts = dateStr.split('-');
  if (parts.length !== 3) return dateStr;
  const day = parseInt(parts[2], 10);
  const month = parseInt(parts[1], 10) - 1;
  const year = parts[0];
  return `${day} ${TURKISH_MONTHS[month] || ''} ${year}`;
}

/**
 * Set document title and meta description
 */
export function setPageMeta(title, description) {
  document.title = title ? `${title} | Prof. Dr. Nilüfer Yıldırım` : 'Prof. Dr. Nilüfer Yıldırım | Fonksiyonel Tıp';
  
  let meta = document.querySelector('meta[name="description"]');
  if (!meta) {
    meta = document.createElement('meta');
    meta.name = 'description';
    document.head.appendChild(meta);
  }
  meta.content = description || 'Prof. Dr. Nilüfer Yıldırım Fonksiyonel Tıp Kliniği - Sağlığınıza bütüncül yaklaşım, kişiye özel çözümler.';
}
